import { Container } from '@mui/material'
import React from 'react'
import LoginForm from '../components/auth'
import {useAppDispatch} from "../redux";
import {login} from "../redux/slices/account";
import { useNavigate } from "react-router-dom";

export default function Login() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();

    const onSubmit = async (data: any) => {
        const loginUser = await dispatch(login({
            email: data.email,
            password: data.password
        }))

        if (!loginUser.payload.errors?.length) {
            navigate('/account')
        }
    }

    return (
        <Container>
            <LoginForm form='login' onSubmitForm={onSubmit} />
        </Container>

    )
}
